var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#8247E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.859 31.4481C51.9452 30.9258 50.7702 30.9258 49.7258 31.4481L42.4151 35.7567L37.4543 38.4985L30.2742 42.8071C29.3603 43.3294 28.1854 43.3294 27.141 42.8071L21.5274 39.4125C20.6136 38.8902 19.9608 37.8457 19.9608 36.6706V30.1424C19.9608 29.0979 20.483 28.0534 21.5274 27.4006L27.141 24.1365C28.0548 23.6142 29.2298 23.6142 30.2742 24.1365L35.8877 27.5312C36.8016 28.0534 37.4543 29.0979 37.4543 30.273V34.5816L42.4151 31.7092V27.27C42.4151 26.2255 41.893 25.181 40.8486 24.5282L30.4047 18.3917C29.4909 17.8694 28.3159 17.8694 27.2715 18.3917L16.5666 24.6588C15.5222 25.181 15 26.2255 15 27.27V39.543C15 40.5875 15.5222 41.632 16.5666 42.2849L27.141 48.4214C28.0548 48.9436 29.2298 48.9436 30.2742 48.4214L37.4543 44.2433L42.4151 41.3709L49.5953 37.1929C50.5091 36.6706 51.6841 36.6706 52.7285 37.1929L58.342 40.457C59.2559 40.9792 59.9086 42.0237 59.9086 43.1988V49.727C59.9086 50.7715 59.3864 51.816 58.342 52.4688L52.859 55.7329C51.9452 56.2552 50.7702 56.2552 49.7258 55.7329L44.1123 52.4688C43.1984 51.9466 42.5457 50.9021 42.5457 49.727V45.549L37.5849 48.4214V52.73C37.5849 53.7745 38.1071 54.819 39.1514 55.4718L49.7258 61.6083C50.6397 62.1306 51.8146 62.1306 52.859 61.6083L63.4334 55.4718C64.3473 54.9496 65 53.905 65 52.73V40.3264C65 39.2819 64.4778 38.2374 63.4334 37.5846L52.859 31.4481Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.c5929dece1c0ce57b6186b728d36e141.svg";
export { ForwardRef as ReactComponent };